import { Component, OnInit, HostListener ,AfterViewInit,ViewChild,TemplateRef} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { sessionService } from '../../service/session.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-mypackagedetail',
  templateUrl: './mypackagedetail.component.html',
  styleUrls: ['./mypackagedetail.component.css'],
  providers: [TestSeriesService,sessionService],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})

export class MypackagedetailComponent implements OnInit,AfterViewInit {
  @ViewChild("feedbackf") public feedbackf: TemplateRef<any>;
  modalReference: NgbModalRef;
  typetxt:any;
  paperDetail:any;
  totalrow:any = 0;
  notfound:any;
  isPostLoad:any=true;
  msg:any='';
  isRemaningForum:any;
  postId:any=0;
  ngload:any;
  userData:any;
  filter:any;
  noMoreResults:any;
  isError=false;
  attactmentlist:any=[];
  questionCount:any=[];
  uploadData:any={};
  msgclass:any;
  isclickbuttonRegisterprofile=false;
  attachmenterror:any='';
  isAttachment = true;
  alreadyUploaded=false;
  closeResult: string;
  currentDate = new Date();
  uploadedAnsSheet:any=false;
  uploadDownloadUrl = '';
  attachmenterrorMSG:any;
  percentDone = 0;
  shwDownloadProgressBar = [];
  progress:any=0;
  isSuccessFeedBack=false;
  isErrorFeedBack=false;
  msgFeedBack:any='';
  isclickbuttonFeedback=false;

  constructor(private http:HttpClient, private _session:sessionService,private modalService: NgbModal,private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.paperDetail = {
                        title:'',
                        testSery:{},
                        detail:'',
                        maxMarks:'',
                        publishDate:'',
                        submissionDate:'',
                      };                 

  this.uploader.onWhenAddingFileFailed = (item: any, filter: any, options: any) => {
      switch (filter.name) {
        case 'fileSize':
        this.isAttachment=true;;
        this.attachmenterror ="Invalid sheet size. Uploaded sheet must be less than 100MB."
        break;
        default:
        this.isAttachment=true;;
        this.attachmenterror ="Something went wrong. Please try to upload again."
        break;
      }
    }


    this.route.params.subscribe((params: Params) => {
      if(params['id']){      
      this.postId = parseInt( atob(params['id']) ) ;
      if(isNaN(this.postId)){
        this.postId=0;
        this.router.navigateByUrl('/home');
      } 

        if(this.postId >0){
          this.gettestpaperdata();
        } 
      }
    });
  }

  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.tsAnsFolder+'&mediaFor=studentAnswerSheet';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to'),allowedMimeType: ['application/pdf','application/zip'],maxFileSize: 100*1024*1024});
  
  

  ngOnInit() {
    this.attachmenterrorMSG="Please upload pdf or zip file.";
    this.uploadData={};
    this.getStudentUploadList();
    
    //disable feedback 
    //this.getfeedback();
  }

  gettestpaperdata(){
    var obj = {};
    obj['id'] = this.postId;
    this.testseriesservice.gettestpaperdata(obj).subscribe((data:any)=>{
      this.isPostLoad = false;
      if(data.error==0){ 
        this.paperDetail =data.results[0];

        var structure = this.paperDetail.testPaperStructures;
        if(structure.length>0){
          for(let s of structure){
            if(s.parentLevel==1) this.questionCount.push(s);
          }
        }
      
        if(this.commonService.user.id>0){
             this.checkuserpackage(this.commonService.user.id,this.paperDetail.testSery.id);
        }else{
          this.router.navigate(['/']);
        }

      }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="Please check your internet connection and try again";
      this.isPostLoad = false;
    })
  }

  checkuserpackage(UserId,tsId){
    if(tsId>0){
      var obj = {};
      obj['UserId'] = UserId;
      obj['tsId'] = tsId;
      this.testseriesservice.checkuserpackage(obj).subscribe((data:any)=>{
          if(data.error==0){
            return true;
          }else{
            this.router.navigate(['/']);
          }
      },(error : HttpErrorResponse)=>{      
        this.router.navigate(['/']);
      });
    }
  }
  
  getTPpdf(imagename){
    return this.global.testseriesImageUrl+imagename;
    
  }

  getExpireDate(lastDate){
    var date = new Date();
    var ld = new Date(lastDate);
     if(date>ld) return true ;
     else return false;
   }

   getDate(dt) {
    return new Date(dt);
   }


   downloadAttachment(fileName,type='',obj){

    if(type=='upload'){
      var downloadurl=this.global.tsAnsImageUrl+fileName;
    }else{
      var downloadurl=this.global.testseriesImageUrl+fileName;
    }
    
    this.percentDone = 0;
    this.shwDownloadProgressBar[fileName] = true;

    const req = new HttpRequest('GET', downloadurl, {
      reportProgress: true,
      responseType: 'blob'
    });

    this.http.request(req).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
         // console.log('Request sent!');
          break;
        case HttpEventType.ResponseHeader:
         // console.log('Response header received!');
          break;
        case HttpEventType.DownloadProgress:
          this.percentDone = Math.round(100 * event.loaded / event.total);
         // console.log( this.percentDone);
          break;
        case HttpEventType.Response:
         // console.log('Done!', event);
          let file = event.body;
         // console.log(file.size + " bytes file downloaded. File type: ", file.type);                
          // create and download link
          var url = window.URL.createObjectURL(file);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element */

      }

    }, error => {
      if(error.status="404"){
             alert('Something went wrong. Please try to latter.');
             this.percentDone = 0;
             this.shwDownloadProgressBar[fileName] = false ;
      }
    }, () => {
      this.shwDownloadProgressBar[fileName] = false ;
      this.percentDone = 0;
     });
  }



  updateProfile(profiledata:NgForm){
    this.isclickbuttonRegisterprofile=true;
    var user = {};
    user['studentId']=this.commonService.user.id;
    user['testSeriesId']=this.paperDetail.testSeriesId;
    user['testPaperId']=this.paperDetail.id;
    user['fileName']=this.uploadData.uploadname;
    user['mediaId']=this.uploadData.id;
 
   if(Object.keys(this.uploadData).length > 0){ 
      this.testseriesservice.uploadanswersheet(user).subscribe((data:any)=>{
        window.scrollTo(0,0);
          if(data.error==0){
            this.isclickbuttonRegisterprofile=false;
            this.uploadDownloadUrl = this.uploadData.uploadname;
            this.uploader.queue=[];
            this.d('');
            this.msgclass="success";
            this.alreadyUploaded=true;
            this.msg="Answer Sheet is uploaded successfully";
            this.modalReference.close();
          }else{
            this.msgclass="danger";
            this.msg="Already Uploaded!";
            this.modalReference.close();
            this.getStudentUploadList();
          }
      },(error : HttpErrorResponse)=>{      
        this.msg="internal server error!";
        this.msgclass="danger";
      });  

    }else{
        this.isAttachment=true;
        this.attachmenterror=this.attachmenterrorMSG;
        this.isclickbuttonRegisterprofile=false;
    }
  }

  open2(content) { 
    this.attachmenterrorMSG="Please upload pdf or zip file.";
    this.msg="";
    this.modalReference = this.modalService.open(content, { size: 'lg',keyboard: false,backdrop:'static' });
    this.uploadData={};
    this.uploader.clearQueue();
    this.isAttachment=false;
  }
  d(id:string){
  }
  
  getStudentUploadList(){
    let obj={}
    obj['userId']= (this.commonService.user) ? this.commonService.user.id : 0;  
    obj['testPaperId']=this.postId;  
    
    this.testseriesservice.getStudentUploadList(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.uploadedAnsSheet =data.results;
        this.uploadDownloadUrl = this.uploadedAnsSheet.fileName;
        this.alreadyUploaded=(this.uploadedAnsSheet.fileName!='')?true:false;
      }
    },
    (error : HttpErrorResponse)=>{
      this.isAttachment=true;;
      this.attachmenterror ="Please check your internet connection and try again."
    }) 
  }

  /*************UPLOAD FUNCTIONS************** */
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
  }

  onFileChanged(event) {
    if(Object.keys(this.uploadData).length > 0){ 
          if(confirm("do you want to override previously uploaded answer sheet?")){
            this.uploadData={};      
            this.uploader.uploadAll();
            this.progress=0;
          }else{
             this.uploader.queue[this.uploader.queue.length-1].remove();
          }
     }else{   
      this.uploader.uploadAll();
      this.progress=0;
     }
   }

  closenotification(variable){
    this[variable]="";
   }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response); //success server response
      if(data.error==0){
        this.progress=1;
        this.isAttachment=false;
        this.uploadData=data.result.mediaDetail;
      }       
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        this.isAttachment=true;;
        this.attachmenterror ="Please check your internet connection and try again."
  }
  
  feedback(postData){
    if(postData.status=="INVALID"){
      this.isErrorFeedBack=true;
      this.msgFeedBack = "Please fill all required fields.";
     }else{
      this.isclickbuttonFeedback=true;
      this.isErrorFeedBack=false;
      postData.value.userid=this.commonService.user.id;
      postData.value.stream=this.paperDetail.testSery.streamId;

      this.testseriesservice.addfeedback(postData.value).subscribe((data : any)=>{
        this.isclickbuttonFeedback=false;
        if(data.error==0){ 
          this.msgFeedBack = data.message;
          this.isErrorFeedBack=false;
          this.isSuccessFeedBack= true;

        }else{
          if(data.message=="Failed to authenticate token."){
            //this.router.navigate(['/admin']);
          }else{
          this.msgFeedBack = data.message;
          this.isErrorFeedBack = true;
          }
        }
    },
        (error : HttpErrorResponse)=>{
          this.isclickbuttonFeedback=false;
          this.isErrorFeedBack = true;
          this.msgFeedBack="Please check your internet connection and try again.";
        });



      
     }
}

getfeedback(){
  if(this.commonService.user){
    var userid=this.commonService.user.id;
  }else{
    return false;
  }
  this.testseriesservice.getfeedback({userid:userid}).subscribe((data : any)=>{
    if(data.error==0){ 
      this.open2(this.feedbackf);
    }else{
     return false;
    }
},
    (error : HttpErrorResponse)=>{
      this.isErrorFeedBack = true;
      this.msgFeedBack="Please check your internet connection and try again.";
    });

}
}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/mypackagedetail/mypackagedetail.component.ts